module.exports = __webpack_public_path__ + "static/img/wxpay.cb650abb.png";